import BOSInput from 'Components/Generic/BOSInput';
import ErrorMessage from 'Components/Generic/Misc/ErrorMessage';
import PropTypes from 'prop-types';
import { getClickableLink } from 'Util';
import styles from './DetailTable.module.css';

const DetailTable = ({
  fieldNames = ['label', 'value'],
  data = [],
  children,
  editable = false,
  verticalAlignCentered = false,
  compact = false,
}) => {
  let getTableRow = (columns, row) => {
    return columns.map((fieldName, index) => {
      let fieldValue = row[fieldName];
      let fieldContent;
      let errorContent;

      let fieldShouldBeEditable =
        editable &&
        row.editableFields?.includes(fieldName) &&
        (row.onEdit || fieldValue?.render);

      errorContent = fieldShouldBeEditable && row.fieldShouldBeValidated && (
        <ErrorMessage style={{ padding: 4 }} message={row.errorMessage} small />
      );

      if (fieldValue?.render) {
        fieldContent = fieldValue.render(editable, row.blurField);
      } else {
        fieldContent = fieldValue;

        if (!fieldShouldBeEditable && row?.format) {
          fieldContent = row.format(fieldValue, fieldName);
        } else if (fieldShouldBeEditable) {
          fieldContent = (
            <BOSInput
              key={row.fieldName}
              readOnly={row.readOnly}
              value={fieldValue}
              onChange={row.onEdit}
              isRequired={row.isRequired}
              showClear={true}
              onBlur={row.blurField}
            />
          );
        } else if (row.urlFields?.includes(fieldName)) {
          fieldContent = (
            <a
              href={getClickableLink(fieldValue)}
              target='_blank'
              rel='noreferrer'
              onMouseDown={(e) => e.preventDefault()}>
              {fieldContent}
            </a>
          );
        } else if (row.emailFields?.includes(fieldName)) {
          fieldContent = (
            <a
              href={`mailto:${fieldValue}`}
              onMouseDown={(e) => e.preventDefault()}>
              {fieldContent}
            </a>
          );
        }
      }

      return (
        <td
          key={fieldName + index}
          style={verticalAlignCentered ? { verticalAlign: 'middle' } : {}}
          className={
            index === 0
              ? compact
                ? styles.first_detail_cell_compact
                : fieldNames.length > 2
                ? styles.first_detail_cell
                : styles.first_detail_cell_label
              : fieldNames.length > 2
              ? styles.centered_detail_cell
              : editable
              ? styles.detail_cell
              : compact
              ? styles.detail_cell_read_only_compact
              : styles.detail_cell_read_only
          }>
          {fieldContent}
          {errorContent}
        </td>
      );
    });
  };

  return (
    <table
      style={{
        width: '100%',
        // tableLayout: 'fixed',
        ...(!compact && { borderCollapse: 'revert', borderSpacing: 'revert' }),
      }}>
      <tbody>
        {data.map((row, index) => {
          return <tr key={index}>{getTableRow(fieldNames, row, index)}</tr>;
        })}
        {children}
      </tbody>
    </table>
  );
};

DetailTable.propTypes = {
  fieldNames: PropTypes.array,
  data: PropTypes.array,
  children: PropTypes.node,
  editable: PropTypes.bool,
  verticalAlignCentered: PropTypes.bool,
  compact: PropTypes.bool,
};

export default DetailTable;
